import { Box } from '@mui/material';

import Filter from '../../../../../../common/reports/actions/utils/filter';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../../locales';
import { AirtimeReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: AirtimeReportDetailsMetadataResponse;
}

const DetailsFilters = ({ filters }: Props) => (
  <Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.common.filters.startingDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.from })}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.common.filters.endDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.common.filters.operators.label}
          value={reportDetailsFilterValuesFormatter(filters.operators)}
        />
      </Box>
      <Box width="50%">
        <Filter label={locales.common.filters.skus.label} value={reportDetailsFilterValuesFormatter(filters.skus)} />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.common.filters.statuses.label}
          value={reportDetailsFilterValuesFormatter(filters.statuses)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.common.filters.operationIds.label}
          value={reportDetailsFilterValuesFormatter(filters.operationIds)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.common.filters.acquirerMsisdns.label}
          value={reportDetailsFilterValuesFormatter(filters.acquirerMsisdns)}
        />
      </Box>
    </Box>
  </Box>
);

export default DetailsFilters;
